/* global axios */
import ApiClient from './ApiClient';

export class MetaAgentAPI extends ApiClient {
  // `resource`: 'ai/meta_agent' (Click Agent de configuração) ou 'office/click_agent'
  // (Click Agent do dia a dia). Mesmas rotas de sessão e mensagem nos dois.
  constructor(resource = 'ai/meta_agent') {
    super(resource, { accountScoped: true, apiVersion: 'v2' });
  }

  // POST /api/v2/accounts/:id/ai/meta_agent/messages ou
  // POST /api/v2/accounts/:id/office/click_agent/messages, conforme `resource`.
  // body: { content, session_id? }
  sendMessage(body, { signal } = {}) {
    return axios.post(`${this.url}/messages`, body, { signal });
  }

  // PATCH /sessions/:id
  updateSession(id, body) {
    return axios.patch(`${this.url}/sessions/${id}`, body);
  }

  // DELETE /sessions/:id
  deleteSession(id) {
    return axios.delete(`${this.url}/sessions/${id}`);
  }

  // POST /sessions/:id/regenerate
  regenerate(sessionId) {
    return axios.post(`${this.url}/sessions/${sessionId}/regenerate`);
  }

  // GET /api/v2/accounts/:id/ai/meta_agent/sessions
  getSessions() {
    return axios.get(`${this.url}/sessions`);
  }

  // GET /api/v2/accounts/:id/ai/meta_agent/sessions/:id/messages
  getMessages(sessionId) {
    return axios.get(`${this.url}/sessions/${sessionId}/messages`);
  }

  // POST /api/v2/accounts/:id/ai/meta_agent/audit_logs/:id/undo
  // Reverts a previously applied audited action; returns the updated audit log.
  undo(auditId) {
    return axios.post(`${this.url}/audit_logs/${auditId}/undo`);
  }

  // POST /api/v2/accounts/:id/ai/meta_agent/audit_logs/:id/confirm
  // Confirmação garantida pelo servidor: aplica de verdade a ação pending que o worker só
  // pré-visualizou. 410 (expirada) e 409 (já decidida) são tratados por quem chama.
  confirmPendingAction(auditId) {
    return axios.post(`${this.url}/audit_logs/${auditId}/confirm`);
  }

  // POST /api/v2/accounts/:id/ai/meta_agent/audit_logs/:id/cancel
  cancelPendingAction(auditId) {
    return axios.post(`${this.url}/audit_logs/${auditId}/cancel`);
  }

  // POST /api/v2/accounts/:id/ai/meta_agent/uploads
  // Returns { signed_id, filename, content_type, byte_size, kind, preview }.
  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/uploads`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new MetaAgentAPI();
